<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Corner_Down_Right"
      data-name="Icon/Corner Down Right"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="13.417"
      viewBox="0 0 14.376 13.417"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Corner-down-right"
        data-name="Icon/Icon/Corner-down-right"
        d="M14.166,7.068,10.332,2.276a.958.958,0,0,0-1.5,1.2l2.589,3.236H2.875a.96.96,0,0,1-.958-.958V.958A.958.958,0,0,0,0,.958V5.75A2.879,2.879,0,0,0,2.875,8.625h8.549L8.835,11.86a.958.958,0,1,0,1.5,1.2l3.834-4.792a.958.958,0,0,0,0-1.2"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CornerDownRightIcon extends Vue {}
</script>

<style></style>
